export type ScrollElementOptions = {
	behavior?: ScrollBehavior
	clearance?: number | [top: number, bottom: number]
}

export const scrollElementInternal = (
	element: HTMLElement,
	scrollElement: HTMLElement,
	type: 'scrollIntoView' | 'scrollToTop',
	{ clearance = 0, behavior }: ScrollElementOptions = {},
) => {
	const [clearanceRatioTop, clearanceRatioBottom] =
		typeof clearance === 'number' ? [clearance, 1 - clearance] : clearance
	const scrollRect = scrollElement.getBoundingClientRect()
	const containerRect = element.getBoundingClientRect()
	// Look outwards in the tree for elements with `[data-scroll-offset]`, to
	// adjust scroll for sticky headers and such
	let scrollOffset = 0
	let scrollOffsetParent: HTMLElement | undefined = element
	// biome-ignore lint/suspicious/noAssignInExpressions: Intentional
	while ((scrollOffsetParent = scrollOffsetParent?.parentElement?.closest('[data-sticky-header-id]') ?? undefined)) {
		scrollOffset += document.getElementById(scrollOffsetParent.dataset.stickyHeaderId!)?.clientHeight ?? 0
	}

	switch (type) {
		case 'scrollIntoView': {
			// Use the other space in the container to calculate clearance. This
			// means 50% clearance centers content.
			const clearSpace = Math.max(0, scrollElement.clientHeight - scrollOffset - containerRect.height)
			const offsetTop = containerRect.top - scrollRect.top - clearSpace * clearanceRatioTop - scrollOffset
			const offsetBottom = containerRect.bottom - scrollRect.bottom + clearSpace * (1 - clearanceRatioBottom)
			if (offsetTop < 0) {
				scrollElement.scrollBy({ top: offsetTop, behavior })
			} else if (offsetBottom > 0) {
				scrollElement.scrollBy({ top: offsetBottom, behavior })
			}
			break
		}
		case 'scrollToTop': {
			const clearSpace = Math.max(0, scrollElement.clientHeight - scrollOffset)
			const offsetTop = containerRect.top - scrollRect.top - clearSpace * clearanceRatioTop - scrollOffset
			scrollElement.scrollBy({ top: offsetTop, behavior })
			break
		}
	}
}
